import React, { useState, useEffect } from 'react';
import mqtt from 'mqtt';

const mqttQOS = 2;
//const mqttBroker = 'ws://broker.hivemq.com:8000/mqtt'; // Example public broker
const mqttBroker = 'ws://mqtt-dev.stoneageconnect.com:8083/mqtt'; // Example public broker
const mqttClientID = 'gwetest-' + Math.random().toString(16).substr(2, 8);
//const topicWildcard = 'sentinel/#';
const topicWildcard = '#';
//const mqttUID = 'sa_broker';
//const mqttPWD = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJHX0RFaURnNERqMTZROHp3ZlNSTm1vRmR2M2NHTDV0WDZlYVNIRVB5QXdZIn0.eyJleHAiOjE3NjI0NDkwNTIsImlhdCI6MTc2MjQ0ODQ1MiwiYXV0aF90aW1lIjoxNzYyNDQ2MjE1LCJqdGkiOiI3NmRjNTk0YS03OGRhLTQ0NDQtYmUwMy0yMzJhZmI0MThhNzUiLCJpc3MiOiJodHRwczovL2lkZW50aXR5LWRldi5zdG9uZWFnZWNvbm5lY3QuY29tL3JlYWxtcy9tYXN0ZXIiLCJhdWQiOiJhY2NvdW50Iiwic3ViIjoiN2NkY2ZjZDEtMDM0MC00YzM3LWJiMjUtMDgyMGUxNzdlNjg3IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoiZW1xeC1kZXYiLCJzaWQiOiI5ZTdjMTNhMi04YzM4LTRhNTAtYTI3Yi05NDI3YWFhNGZhNGUiLCJhY3IiOiIwIiwiYWxsb3dlZC1vcmlnaW5zIjpbIioiLCIvKiIsImh0dHA6Ly9sb2NhbGhvc3Q6MzAwMCJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiZGVmYXVsdC1yb2xlcy1tYXN0ZXIiLCJvZmZsaW5lX2FjY2VzcyIsInVtYV9hdXRob3JpemF0aW9uIl19LCJyZXNvdXJjZV9hY2Nlc3MiOnsiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJvcGVuaWQgb2ZmbGluZV9hY2Nlc3MifQ.ZU_I7yBuvlkpTq3fdZezw9bUkPK9n8kM80yxiHCQ8CCs6Pn2cgMbv8z3fM1icrFkvRo6cGLB7Kb72HsAL3T0BAqcPJefFodbbeO_j8gL9tGxF3wLgjqvnbfV9gn-8kqhpPED6D5lk3NCxxd-hyXqf7zJ3_CW5SmifVFtXxIiOgk4ihXk0DAi_PFTu-RwjDR5iXTqFFsXG2NZbrjKTAHBA0vaN-JIHoFDLaMJWzG80oTmqPTDbt1yE9g6-wBO1ZulSjKhPTUTP0aaHGWW8mgomefOWIKGhLVfDEQtZnbajM2ujFtaAqCoj2UtIcrDCR8vd36xTAW-Rs4yGu70TujNIg"

interface MqttClientProps {
  topic: string;
  message: string;
  mqttUID: string;
  mqttPWD: string;
}

const MqttClient: React.FC<MqttClientProps> = ({ topic, message, mqttUID, mqttPWD }) => {
 
  const [client, setClient] = useState<mqtt.MqttClient | null>(null);
  const [connectionStatus, setConnectionStatus] = useState<string>('Disconnected');
  const [messagePayload, setMessagePayload] = useState<string>('');

  const handleConnect = () => {
  //useEffect(() => {    

    // Set MQTT Broker connection options
    let options: mqtt.IClientOptions = {
      username: mqttUID,
      password: mqttPWD,
      clientId: mqttClientID,
    };

    // Connect to MQTT Broker
    setConnectionStatus('Connecting...');
    options.password = localStorage.getItem('accessToken') || '';
    const mqttClient = mqtt.connect(mqttBroker, options);
      
    mqttClient.on('connect', () => {
        setConnectionStatus('Connected');
        setClient(mqttClient);
        console.log('Connected to MQTT broker');

        // Subscribe at startup
        mqttClient.subscribe(topicWildcard, (err) => {
            if (!err) {
                console.log(`Subscribed to topic: ${topicWildcard}`);
            } else {
                console.error('Subscription error:', err);
            }
        });

        // Publish at startup
        mqttClient.publish(topic, message, { qos: mqttQOS }, (err) => {
            if (err) {
                console.error('Publish error:', err);
            } else {
                console.log(`Message published to ${topic}: ${message}`);
            }

            //Disconnect from MQTT Broker - Commenting out for testing now
            //if (mqttClient) {
            //  mqttClient.end();
            //}
        });
    });

    mqttClient.on('message', (receivedTopic, message) => {
        // Message is a Buffer, convert to string
        const payload = message.toString();
        console.log(`Received Message: ${payload.substring(0,20)} from topic: ${receivedTopic} | Length: ${payload.length}`);

        //FileSaver.saveAs(payload, "my-data.txt");
    });

    mqttClient.on('error', (err) => {
        setConnectionStatus(`Error: ${err.message}`);
        if (err.message.includes('Bad username') ) {
            console.error('MQTT connection error:', err.message + " (Get a new access token)");
        } else {
            console.error('MQTT connection error:', err.message);
        }
        mqttClient.end();
    });

    mqttClient.on('close', () => {
        setConnectionStatus('Disconnected');
        console.log('Disconnected from MQTT broker');
        setClient(null);
    });

    // Disconnect on component unmount
    //return () => {
    //    if (mqttClient) {
    //        mqttClient.end();
    //    }
    //  };
  //}, [topic, message, mqttUID, mqttPWD]);
 // }, []); // Empty dependency array ensures this runs only once on mount
  };

  const handleDisconnect = () => {
    if (client) {
      client.end();
    }
  };

  const handlePublish = () => {
    if (client && client.connected) {
      client.publish(topic, messagePayload, { qos: mqttQOS }, (err) => {
        if (err) {
          console.error('Publish error:', err);
        } else {
          console.log(`Message published to ${topic}: ${messagePayload}`);
        }
        //Disconnect from MQTT Broker
        //if (client) {
        //  client.end();
        //}
      });
    } else {
      console.warn('Cannot publish: Not connected to MQTT broker.');
    }

  };

  return (
    <div>
      <p>Connection Status: {connectionStatus}</p>
      <div>
        <input
          type="text"
          value={messagePayload}
          onChange={(e) => setMessagePayload(e.target.value)}
          placeholder="Enter message to publish"
        />
        &nbsp;<button onClick={handlePublish}>Publish</button>

        <div style={{ marginTop: "20px" }}>
          <button onClick={handleConnect} disabled={client?.connected}>Connect</button>&nbsp;&nbsp;
          <button onClick={handleDisconnect} disabled={!client?.connected}>Disconnect</button>
        </div>
      </div>
    </div>
  );
 };

export default MqttClient;